const swiperCareSlides = document.querySelectorAll('.hoox-care__items .swiper-slide');

const swiperCare = new Swiper('.hoox-care__items', {
    loop: true,
    slidesPerView: 1,
    slidesPerGroup: 1,
    watchOverflow: true,

    breakpoints: {
        768: {
            slidesPerView: 3,
            slidesPerGroup: 3,
            spaceBetween: 60,
            loop: swiperCareSlides > 3
        }
    },

    pagination: {
        el: '.hoox-care__items .hoox-swiper-dots',
        clickable: true,
    },

    navigation: {
        nextEl: '.hoox-care__items .hoox-swiper-next',
        prevEl: '.hoox-care__items .hoox-swiper-prev',
    },
});